import type { HostCapabilities } from "../../capabilities";
import type { MarlinStoreDb } from "../infra/db";
import type { IpJsonContent, LegacyConfig } from "../types";
import * as adoption from "./adoption";
import { createLegacyHost } from "./host";
import { initializeScreens } from "../screens/host";

export const initializeLegacy = async (
  db: MarlinStoreDb,
  capabilities: Pick<HostCapabilities, "files" | "screens">,
  screenId: number,
) => {
  const host = createLegacyHost(db, capabilities);
  const result = await host.adoptFromHost();
  if (result.config?.reason !== "failed" && !result.ipJsonError)
    await initializeScreens(db, capabilities, screenId);
  if (result.config?.adopted) await adoption.recordLegacyAdoptionState(db);
  return {
    result,
    adoptLegacyConfig: (config: LegacyConfig) =>
      adoption.adoptLegacyConfig(db, config),
    importLegacyIpJson: (content: IpJsonContent | null) =>
      adoption.importLegacyIpJson(db, content),
    adoptFromHost: host.adoptFromHost,
    snapshot: () => adoption.snapshotTables(db),
  };
};

export type AdoptionApi = Awaited<ReturnType<typeof initializeLegacy>>;
